<div id="acc-root" class="acc-overlay" (click)="onClose()">
  <section
    class="acc-card ec-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="atc-title"
    (click)="$event.stopPropagation()"
  >
    <h2 id="atc-title">{{ 'componentsWizard.actionTemplate.title' | translate }}</h2>

    <form class="acc-form ec-form" [formGroup]="form" (ngSubmit)="submit()">
      <!-- Nom -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.actionTemplate.nameLabel' | translate }}</label>
        <input class="acc-input ec-input" type="text" formControlName="name" [placeholder]="'componentsWizard.actionTemplate.namePlaceholder' | translate" />
      </div>

      <!-- Description -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.actionTemplate.descriptionLabel' | translate }}</label>
        <textarea class="acc-input ec-input ec-textarea" rows="6" formControlName="description"
                  [placeholder]="'componentsWizard.actionTemplate.descriptionPlaceholder' | translate"></textarea>
      </div>

      <div *ngIf="errorMsg" class="acc-msg acc-msg--error">{{ errorMsg }}</div>

      <div class="acc-actions ec-actions">
        <button type="button" class="acc-btn acc-cancel" [disabled]="loading" (click)="onClose()">
          {{ 'componentsWizard.actionTemplate.cancel' | translate }}
        </button>
        <button class="acc-btn acc-primary" type="submit" [disabled]="loading || form.invalid">
          {{ (loading ? 'componentsWizard.actionTemplate.creating' : 'componentsWizard.actionTemplate.create') | translate }}
        </button>
      </div>
    </form>
  </section>
</div>